import { module }from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            submit: 'submitForm'
        }
    }

    init() {
        
    }

    submitForm(e) {
        e.preventDefault();
        //Get value of input name="Catégories".
        let cat  = e.target.querySelector('select[name="Catégories"]').value;
        let q = e.target.querySelector('input[name="q"]').value;

        window.load.goTo(cat + '?q=' + q + '#BlogFilter');
    }
}
